import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

const translateUnitStatus = (item: string): string => {
  let name: string = item;
  const translateObject: any = {
    Launched: i18n.tc(LocalesFields.Started),
    Completed: i18n.tc(LocalesFields.Completed),
    Passed: i18n.tc(LocalesFields.Passed),
    CompletedAndPassed: i18n.tc(LocalesFields.CompletedAndPassed),
    Failed: i18n.tc(LocalesFields.Failed),
    Waived: i18n.tc(LocalesFields.Waived),
    Abandoned: i18n.tc(LocalesFields.Abandoned),
    Satisfied: i18n.tc(LocalesFields.Satisfied)
  };

  for (let key in translateObject) {
    if (translateObject.hasOwnProperty(key)) {
      if (key === name) {
        name = translateObject[key];
      }
    }
  }

  return name;
};

export { translateUnitStatus };
